"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement(_antd.Breadcrumb, null, /*#__PURE__*/_react.default.createElement(_antd.Breadcrumb.Item, null, "Home"), /*#__PURE__*/_react.default.createElement(_antd.Breadcrumb.Item, null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Application Center")), /*#__PURE__*/_react.default.createElement(_antd.Breadcrumb.Item, null, /*#__PURE__*/_react.default.createElement("a", {
    href: ""
  }, "Application List")), /*#__PURE__*/_react.default.createElement(_antd.Breadcrumb.Item, null, "An Application"));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorText', 'colorPrimary', 'colorPrimaryActive', 'colorPrimaryHover'],
  key: 'breadcrumb'
};
var _default = exports.default = componentDemo;